const ModeIcon = () => {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle
                cx="4.86565"
                cy="4.86565"
                r="4.86565"
                transform="matrix(1 0 0 -1 14.2686 23.736)"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.2666 0.900404C18.3639 1.83772 21.5633 5.03714 22.5006 9.1344"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.16699 13.9996C2.10324 18.0979 5.30293 21.2985 9.40099 22.236"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.40099 0.900404C5.30402 1.83825 2.10484 5.03744 1.16699 9.1344"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ModeIcon;
